// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".3942e2e97f5a62ed8f0b79c79a83202f17cc6782.chunk.js";
};